import React from 'react';
import './style.css';

import Button from '@elements/Button';
import RichText from '@elements/RichText';
import { getClasses } from '@utils';

type CommonCellProps = {
  cidx: number;
  className?: string;
  subClassName?: string;
  cell: {
    cid: string;
    modulename: string;
    moduletype: string;
    modulereference;
    modulerichtext;
  };
};

const CommonCell = ({ cell, className, subClassName = "", cidx }: CommonCellProps): JSX.Element => {

  const renderBody = () => {

    if (cell.moduletype === 'form') {
      return (
        <RichText bodyRichText={cell.modulerichtext} classes={subClassName} />
      );
    } else if (cell.moduletype === 'reference') {
      switch (cell.modulereference?.contentType) {
        case 'buttonCta': {
          const { title, ctaLink, color, position, size } = cell.modulereference;
          return (
            <div className={getClasses(`btn--cta-${position}`, `btn--${size}`, `btn--cta`)}>
              <Button childClassName={`btn--${color}`} href={ctaLink}>{title}</Button>
            </div>
          );
        }
        default:
          return <></>;
      }
    }

    return (
      <></>
    );

  };

  return (
    <li
      className={getClasses("common-container-cell", className)}
      id={`container-cell-item-${cidx}`}
    >
      {renderBody()}
    </li>
  );
};

export default CommonCell;
